import React from 'react'
import './HeroSection.css';
import '../App.css';
import heroImage from '../images/optimized/hero-game-design-v5.webp';

function HeroSection() {
  return (
    <div className='hero-container'>
      <img
        className='hero-background'
        src={heroImage}
        width='1600'
        height='900'
        alt=''
        aria-hidden='true'
        decoding='async'
        fetchpriority='high'
      />
      <h1>Hello, I'm Jeff</h1>
      <p className='page-paragraph'>I'm Senior Game Designer and AI Enthusiast</p>
      {/*
      <div className="hero-btns">
        <Button 
          className="btns" 
          buttonStyle='btn--outline' 
          buttonSize='btn--large'
        >
          Get your design
        </Button>
        <Button 
          className="btns" 
          buttonStyle='btn--primary' 
          buttonSize='btn--large'
        >
          Have a tour <i className='far fa-play-circle' />
        </Button>
      </div>
      */}
    </div>
  )
}

export default HeroSection
